import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { CACHE_CONFIG } from "@kno2/core/http";
import { filterNonEmptyProperties } from "@kno2/utils";
import { firstValueFrom } from "rxjs";
import {
    QueryDocumentMetadata,
    QueryDocumentQueryRequest,
    QueryDocumentRetrieveRequest,
    QueryOrganizationInfo,
    QueryOrganizationSearch,
    QueryPatientDiscoveryRequest,
    QueryPatientQueryResponse,
    QueryPurposeOfUse,
    QuerySendDocumentToIntakeRequest
} from "./query-api.models";

@Injectable({
    providedIn: "root"
})
export class QueryApiService {
    private readonly http = inject(HttpClient);

    public getPurposesOfUse(): Signal<QueryPurposeOfUse[]> {
        return toSignal(
            this.http.get<QueryPurposeOfUse[]>(`/api/query/purposesofuse`, {
                context: new HttpContext().set(CACHE_CONFIG, { isEnabled: true })
            }),
            {
                initialValue: []
            }
        );
    }

    public searchOrganizations(search: Partial<QueryOrganizationSearch>): Promise<QueryOrganizationInfo[]> {
        return firstValueFrom(this.http.post<QueryOrganizationInfo[]>("/api/query/organizations", filterNonEmptyProperties(search)));
    }

    public queryPatientsByFacility(request: QueryPatientDiscoveryRequest): Promise<QueryPatientQueryResponse> {
        return firstValueFrom(this.http.post<QueryPatientQueryResponse>("/api/query/patient/demographics", request));
    }

    public queryDocuments(request: QueryDocumentQueryRequest): Promise<QueryDocumentMetadata[]> {
        return firstValueFrom(this.http.post<QueryDocumentMetadata[]>("/api/query/document", request));
    }

    public retrieveDocument(request: QueryDocumentRetrieveRequest): Promise<string[]> {
        return firstValueFrom(this.http.post<string[]>("/api/query/document/retrieve", request));
    }

    public sendToIntake(request: QuerySendDocumentToIntakeRequest): Promise<{ id: string }> {
        return firstValueFrom(this.http.post<{ id: string }>("/api/query/senddocumenttointake", request));
    }
}
